import { Pipe, PipeTransform, inject } from '@angular/core';
import { HolidayRegionCode } from '@wilson/interfaces';
import { HolidaysService } from '../holidays.service';

@Pipe({
  name: 'getPublicHolidayName',
})
export class GetPublicHolidayPipe implements PipeTransform {
  private holidaysService = inject(HolidaysService);

  transform(date: Date, holidayRegions: HolidayRegionCode | null | undefined) {
    return this.holidaysService.getPublicHolidayName({ date, holidayRegions });
  }
}
